module.exports = __webpack_public_path__ + "55595ec0b6ef04e47f952705f1abdf79.png";